import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { style } from "./styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import InputFormat from "../../../partials/inputForm";
import Dialog from "@material-ui/core/Dialog";

class ServiceAlbum extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      productName: "",
      checked: [],
      productList: [],
      fullWidth: true,
      maxWidth: "sm",
    };
  }
  handleOpenModal = (url, index) => {
    this.setState({
      openModal: true,
      checked: [],
      productName: "",
      productList: [],
    });
  };

  handleCloseModal = () => {
    this.setState({ openModal: false });
  };
  componentDidMount() {
    this.props.onRef(this);
  }
  handleChange = async (e) => {
    this.setState({
      productName: e.target.value,
    });
    if (e.target.value) {
      let result = await this.props.getProduct({
        search: e.target.value,
        limit: 10,
        offset: 0,
      });
      this.setState({ productList: result.data });
    }
  };
  handleToggle = (value) => () => {
    let { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    this.setState({ checked: newChecked });
  };
  addRelatedProduct = () => {
    this.props.addRelatedProduct(this.state.checked);
  };
  render() {
    const { classes, t } = this.props;
    let { productName, checked, productList } = this.state;
    return (
      <div className={classes.root}>
        {/* <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.state.openModal}
                    onClose={this.handleCloseModal}
                > */}
        <Dialog
          fullWidth={this.state.fullWidth}
          maxWidth={this.state.maxWidth}
          open={this.state.openModal}
          onClose={this.handleCloseModal}
          aria-labelledby="max-width-dialog-title"
        >
          <Paper className={classes.paper}>
            {/* <LabelForm label = {"Add Related product"}/> */}
            <InputFormat
              name="productName"
              label={t("product_search_product")}
              margin="normal"
              value={productName}
              onChange={this.handleChange}
            />

            <List className={classes.root}>
              {productList.map((value) => {
                const labelId = `checkbox-list-label-${value}`;

                return (
                  <ListItem
                    key={value}
                    role={undefined}
                    dense
                    button
                    onClick={this.handleToggle(value)}
                  >
                    <ListItemIcon>
                      <Checkbox
                        edge="start"
                        checked={checked.indexOf(value) !== -1}
                        tabIndex={-1}
                        disableRipple
                        inputProps={{ "aria-labelledby": labelId }}
                      />
                    </ListItemIcon>
                    <ListItemText id={labelId} primary={value.name} />
                    <ListItemSecondaryAction>
                      <ListItemText id={labelId} primary={value.price} />
                    </ListItemSecondaryAction>
                  </ListItem>
                );
              })}
            </List>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                variant="default"
                style={{ marginRight: "1rem" }}
                color="primary"
                onClick={() => this.handleCloseModal()}
              >
                {" "}
                {t("product_cancel")}{" "}
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => this.addRelatedProduct()}
              >
                {" "}
                {t("product_add")}{" "}
              </Button>
            </div>
          </Paper>
        </Dialog>
      </div>
    );
  }
}

ServiceAlbum.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({
  getProduct: dispatch.product.getProduct,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(style, { withTheme: true })(ServiceAlbum)
  )
);
